export default __webpack_public_path__ + "static/media/definite.9606d071.wav";